/** Project step UI for the welcome onboarding flow (#project assignment). */
import { Box, Button, TextField, Typography } from '@mui/material';
import { useT } from '@/i18n/useT';
import { ONBOARDING_WELCOME_STEP_TEST_IDS } from '@/features/onboarding/constants/welcomeStepTestIds';

/**
 * @param {Object} props
 * @param {React.RefObject<HTMLInputElement | null>} props.projectInputRef
 * @param {string} props.projectInput
 * @param {(value: string) => void} props.setProjectInput
 * @param {{ projects?: string[] }} props.parsedProject
 * @param {boolean} props.projectDone
 * @param {() => void | Promise<void>} props.onProjectSubmit
 */
const OnboardingWelcomeProjectStep = ({
  projectInputRef,
  projectInput,
  setProjectInput,
  parsedProject,
  projectDone,
  onProjectSubmit,
}) => {
  const t = useT();
  const hasProjects = (parsedProject.projects?.length ?? 0) > 0;

  return (
    <Box data-testid={ONBOARDING_WELCOME_STEP_TEST_IDS.project}>
      <Typography variant="h5" component="h1" gutterBottom>
        {t('onboarding.projectStep.title', 'Waar hoort dit bij?')}
      </Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
        {t(
          'onboarding.projectStep.body',
          'Een project bundelt taken die bij elkaar horen, zoals een klant of een verhuizing. Je herkent ze aan de #: typ er één, bijvoorbeeld #werk.',
        )}
      </Typography>
      <TextField
        fullWidth
        size="small"
        inputRef={projectInputRef}
        value={projectInput}
        onChange={(e) => setProjectInput(e.target.value)}
        placeholder={t('onboarding.projectStep.placeholder', '#werk')}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            if (hasProjects && !projectDone) {
              void onProjectSubmit();
            }
          }
        }}
      />
      <Button
        variant="contained"
        sx={{ mt: 2 }}
        disabled={!hasProjects || projectDone}
        onClick={() => void onProjectSubmit()}
      >
        {t('onboarding.projectStep.submit', 'Volgende')}
      </Button>
    </Box>
  );
};

export default OnboardingWelcomeProjectStep;
